module.exports = __webpack_public_path__ + "img/gup.b9d1ecd7.svg";